import { API_REQUEST } from 'redux-api-request/dist/action_types'
import cloneDeep from 'lodash/cloneDeep'

export function createActionsFor(resource) {
  var {
    RESOURCE, 
    RESOURCE_SINGULAR,
  } = createLabels(resource);

  return {
    getMany: (query = null) => ({
      type:API_REQUEST,
      method: 'GET',
      endpoint: `/api/${resource}`,
      query: query,
      request: `${RESOURCE}_GET_REQUEST`,
      success: `${RESOURCE}_GET_SUCCESS`,
      failure: `${RESOURCE}_GET_ERROR`
    }),
    get: (id) => ({
      type: API_REQUEST,
      method: 'GET',
      endpoint: `/api/${resource}/${id}`,
      request: `${RESOURCE_SINGULAR}_GET_REQUEST`,
      success: `${RESOURCE_SINGULAR}_GET_SUCCESS`,
      failure: `${RESOURCE_SINGULAR}_GET_ERROR`,
    }),
    update: (id, props) => ({
      type:API_REQUEST,
      method: 'PUT',
      endpoint: `/api/${resource}/${id}`,
      body: props,
      request: `${RESOURCE_SINGULAR}_UPDATE_REQUEST`,
      success: `${RESOURCE_SINGULAR}_UPDATE_SUCCESS`,
      failure: `${RESOURCE_SINGULAR}_UPDATE_ERROR` 
    }),
    create: (props) => ({
      type:API_REQUEST,
      method: 'POST',
      endpoint: `/api/${resource}/`,
      body: props,
      request: `${RESOURCE_SINGULAR}_CREATE_REQUEST`,
      success: `${RESOURCE_SINGULAR}_CREATE_SUCCESS`,
      failure: `${RESOURCE_SINGULAR}_CREATE_ERROR`,
    }),
    delete: (id) => ({
      type:API_REQUEST,
      method: 'DELETE',
      endpoint: `/api/${resource}/${id}`,
      request: `${RESOURCE_SINGULAR}_DELETE_REQUEST`,
      success: `${RESOURCE_SINGULAR}_DELETE_SUCCESS`,
      failure: `${RESOURCE_SINGULAR}_DELETE_ERROR`,
    }),
    new: () => ({
      type: `NEW_${RESOURCE_SINGULAR}`,
    }),
    editStart: () => ({
      type: `EDIT_${RESOURCE_SINGULAR}_START`,
    }),
    editCancel: () => ({
      type: `EDIT_${RESOURCE_SINGULAR}_CANCEL`,
    }),
  }

}

export function createReducerFor(resource, defaults) {

  var { RESOURCE, RESOURCE_SINGULAR } = createLabels(resource);

  const getDefaults = typeof defaults === 'function' 
    ? defaults 
    : () => cloneDeep(defaults);

  return (state={data: [], singular: {isEditing: false, data: {} }}, action) => {

    switch(action.type) {
      // START CREATE NEW
      case `NEW_${RESOURCE_SINGULAR}`:
        return {
          ...state,
          singular: {
            // TODO: get default fields per user type from somewhere else
            data: getDefaults(),
            isEditing: true,
            isNew: true,
          }
        }
      // GET: MANY
      case `${RESOURCE}_GET_REQUEST`:
        return {
          ...state,
          isFetching: true,
        }
      case `${RESOURCE}_GET_SUCCESS`:
        var { docs, ...paginationProps } = action.result;
        return {
          ...state,
          isFetching: false,
          pagination: paginationProps,
          // data: action.result,
          data: docs,
          error: false,
        }
      case `${RESOURCE}_GET_ERROR`:
        return {
          ...state,
          isFetching: false,
          error: action.payload,
        }
      // GET: SINGULAR
      case `${RESOURCE_SINGULAR}_GET_REQUEST`:
        return {
          ...state,
          singular: {
            ...state.singular,
            data: {},
            error: false,
            isFetching: true,
            isNew: false,
          }
        }
      case `${RESOURCE_SINGULAR}_GET_SUCCESS`:
        // history.push(`/consultants/`)
        return {
          ...state,
          singular: {
            ...state.singular,
            isFetching: false,
            data: action.result,
            error: false,
          }
        }
      case `${RESOURCE_SINGULAR}_GET_ERROR`:
        return {
          ...state,
          singular: {
            ...state.singular,
            data: null,
            isFetching: false,
            error: action.payload,
          }
        }
      // CREATE: SINGULAR
      case `${RESOURCE_SINGULAR}_CREATE_REQUEST`:
        return {
          ...state,
          singular: {
            ...state.singular,
            error: false,
            isCreating: true,
          }
        }
      case `${RESOURCE_SINGULAR}_CREATE_SUCCESS`:
        return {
          ...state,
          singular: {
            ...state.singular,
            isCreating: false,
            isEditing: false,
            data: action.result,
            error: false,
            isNew: false,
          }
        }
      case `${RESOURCE_SINGULAR}_CREATE_ERROR`:
        return {
          ...state,
          singular: {
            ...state.singular,
            error: action.payload,
            isCreating: false,
          }
        } 
      // UPDATE
      case `${RESOURCE_SINGULAR}_UPDATE_ERROR`:
        // TODO: handle update error!
        return state;
      case `${RESOURCE_SINGULAR}_UPDATE_SUCCESS`:
        // console.log(action);
        return {
          ...state,
          singular: {
            ...state.singular,
            data: action.result,
            isEditing: false,
          }
        }
      // EDIT MODE
      case `EDIT_${RESOURCE_SINGULAR}_START`:
        return {
          ...state,
          singular: {
            ...state.singular,
            isEditing: true,
          }
        }
      case `EDIT_${RESOURCE_SINGULAR}_CANCEL`:
        return {
          ...state,
          singular: {
            ...state.singular,
            isEditing: false,
          }
        }

      // DEFAULT
      default:
        return state;
    }

  }
}

export default function createCrudModule(resource, defaults) {
  return {
    actions: createActionsFor(resource),
    reducer: createReducerFor(resource, defaults),
  }
}

export function createLabels(resource) {
  const ResourcePlural = resource.charAt(0).toUpperCase() + resource.slice(1) + 's';
  const ResourceSingular = ResourcePlural.substring(0, ResourcePlural.length - 1);
  const RESOURCE = ResourcePlural.toUpperCase();
  const RESOURCE_SINGULAR = ResourceSingular.toUpperCase();
  const resource_singular = ResourceSingular.toLowerCase();

  return { ResourcePlural, ResourceSingular, RESOURCE, RESOURCE_SINGULAR, resource_singular };
}


// WEBPACK FOOTER //
// ./src/modules/crud/createCrudModule.js